import * as React from 'react';
import type { SVGProps } from 'react';

const BuildingSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="Icon/Building">
      <path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M14 0.00012207H2V16.0001H6V12.0001H10V16.0001H14V0.00012207ZM5 3.00012H7V5.00012H5V3.00012ZM7 7.00012H5V9.00012H7V7.00012ZM9 3.00012H11V5.00012H9V3.00012ZM11 7.00012H9V9.00012H11V7.00012Z" fill="#616061"/>
    </g>
  </svg>
);

export default BuildingSvg;